<template>
  <div
    v-if="options"
    v-element-loader="{ endpoint: 'superuser/cart/merge' }"
    class="merge-cart">
    <h3 class="merge-cart__header">
      {{ tStatic('superUserMergeCartHeader') }}
    </h3>

    <p v-if="options.customerHasCart" class="merge-cart__text">
      {{ tStatic('superUserMergeCartText') }}
    </p>
    <p v-else class="merge-cart__text">
      {{ tStatic('superUserMergeNoCartText') }}
    </p>

    <div v-if="options.customerHasCart" class="merge-cart__actions">
      <oie-base-button
        css-classes="button--ghost button--ghost-green"
        :text="tStatic('superUserMergeCartYesMergeCarts')"
        @click="mergeCarts()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('superUserMergeCartUseSuperUser')"
        @click="useSuperUserCart()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('superUserMergeCartUseCustomers')"
        @click="userCustomerCart()">
      </oie-base-button>
    </div>

    <div v-else class="merge-cart__actions">
      <oie-base-button
        css-classes="button--ghost button--ghost-green"
        :text="tStatic('superUserMergeCartUseSuperUser')"
        @click="useSuperUserCart()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('superUserMergeCartContinue')"
        @click="userCustomerCart()">
      </oie-base-button>
    </div>
  </div>
</template>

<script>

import httpService from '@/core/http-service'

export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  methods: {
    mergeCarts() {
      this.makeSelection('merge')
    },
    useSuperUserCart() {
      this.makeSelection('replace')
    },
    userCustomerCart() {
      this.makeSelection('useSaved')
    },
    makeSelection(action) {
      httpService.xhr('post', `/mvcapi/${this.clientModel.currentMarket}/${this.clientModel.currentLanguage}/superuser/cart/merge`,
        {
          useDeviationEndpoint: true,
          data: {
            action,
            sourceMarket: this.options.sourceMarket
          }
        }).then(({ data }) => {
        window.location.replace(data.url)
      }).catch((e) => {
        // do nothing
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.merge-cart__header {
  margin-top: 0;
}

.merge-cart__text {
  margin-top: 0;
  margin-bottom: measure(full);
}

.merge-cart__actions > button {
  width: 100%;
  margin-bottom: measure(quarter);

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
